export default __webpack_public_path__ + "static/media/aiSpeechInActive.914a3a5b.svg";